{#if show}
	<nav transition:fly={{x: -250, opacity: 1}}>
		<div class="thick-border"></div>
		<div class="thin-border"></div>
		<div class="menu-items">
			<ul>
				<li>
					<a href="/">
						Home
					</a>
				</li>
				<li>
					<a href="/aboutus">
						About us
					</a>
				</li>
				<li>
					<a href="/contactus">
						Contact us
					</a>
				</li>
			</ul>
			<div class="d-flex side-bar-links">
				<div class="item">
					<a href="tel:+919606020090">
						<!-- <img class="w-20 normal-icon" src="/images/phone.png" alt="phone"> -->
						<img class="w-20 active-icon" src="/images/phone-gold.png" alt="phone"> +91 9606020090
					</a>
				</div>
				<div class="item">
					<a href="#" class="text-lowercase">
						<img class="w-20" src="/images/mail-01.png" alt="mail"> admin@lamara.in
					</a>
				</div>
			</div>
		</div>
		<button class="btn close-btn" on:click={() => show = false}>
			<img src="/images/x_mark.png" alt="Close" class="close-icon">
			<img src="/images/x_mark.png" alt="Close" class="close-icon close-icon-active">
		</button>
		<div class="mt-auto bottom-menu">
			<h5 class="sub-title text-uppercase">
				Information
			</h5>
			<div class="item links">
				<a href="/termsofuse">
					Terms of use
				</a>
			</div>
			<div class="item links">
				<a href="/privacy-policy">
					Privacy Policy
				</a>
			</div>
			<div class="item links">
				<a href="/refund-policy">
					Cancellation and Refund
				</a>
			</div>
			<div class="">
				<h5 class="sub-title text-uppercase">
					Services
				</h5>
				<div class="item links">
					<a href="/shipping-and-delivery">
						Shipping and Delivery
					</a>
				</div>
				<!-- <div class="item links">
					<a href="metric-weight-measures">
						Metric / Weights and Measures
					</a>
				</div>
				<div class="item links">
					<a href="foodsafety-sanitation">
						Food Safety and Sanitation
					</a>
				</div> -->
			</div>
			<div class="d-flex social-links">
				<div class="item">
					<a href="https://instagram.com/lamara.in?utm_medium=copy_link" target="_blank">
						<img src="/images/insta-01.png" alt="insta">
					</a>
				</div>
				<div class="item">
					<a href="#" target="_blank">
						<img src="/images/fb-01.png" alt="FB">
					</a>
				</div>
				<!-- <div class="item">
					<a href="#" target="_blank">
						<img src="/images/mail-01.png" alt="mail">
					</a>
				</div>
				<div class="item">
					<a href="#" target="_blank">
						<img src="/images/phone-gold.png" alt="phone" style="margin-top: 4px;">
					</a>
				</div> -->
			</div>
		</div>
	</nav>
	<div class="patch" on:click={() => show = false}></div>
{/if}

<script>
	import { link } from "svelte-navigator";
	import { fly } from 'svelte/transition';
	export let show = false;
</script>
<svelte:head>
	{#if show}
		<style>
			body {
				overflow: hidden;
			}
		</style>
	{/if}
</svelte:head>
<style>

	nav {
		position: fixed;
		display: flex;
		flex-flow: column;
		/*background: url("/images/pattern.png");*/
		z-index: 99;
		top: 0;
		left: 0;
		height: 100%;
		padding: 2rem 24px 0 0;
		border-left: 1px solid #aaa;
		overflow-y: auto;
		width: 20rem;
	}

	nav::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	 	background-image: url("/images/pattern2.png");
        opacity: 1;
		z-index: -1;
	}

	.thick-border {
		position: absolute;
		right: 9px;
		top: 55px;
		width: 6px;
		height: 90%;
		background: rgba(247, 195, 114, 0.75);
		border-radius: 8px;
	}

	.thin-border {
		position: absolute;
		right: 22px;
		top: 55px;
		width: 2px;
		height: 90%;
		background: rgba(247, 195, 114, 0.75);
		border-radius: 8px;
	}

	.patch {
		width: 100%;
		height: 100%;
		background: rgba(0,0,0, 0.6);
		position: fixed;
		z-index: 1;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
	}

	ul {
		padding: 0;
	}

	.menu-items {
		margin-top: 32px;
	}

	.menu-items ul {
		margin-bottom: 4px;
	}

	.menu-items ul li {
		list-style: none;
	}

	.menu-items ul li a {
		color: var(--gray-dark);
		font-size: 13px;
		text-transform: uppercase;
		/*font-weight: 600;*/
		font-family: var(--primary-font);
		display: block;
		padding: 8px 0 8px 30px;
		margin: 2px 0;
	}
	
	.menu-items ul li a:hover {
		background: rgba(247, 195, 114, 0.8);
		color: #fff;
	}

	.close-btn {
		position: absolute;
		top: 0;
		right: 0;
		opacity: 1;
		color: var(--gray-dark);
		font-size: 26px;
	}


	.social-links {
		display: flex;
		margin-top: 30px;
		margin-bottom: 20px;
		justify-content: center;
		align-items: center;
		width: 100%;
	}

	.social-links .item {
		/*min-width: 40px;*/
		margin-left: 15px;
	}

	.social-links .item:first-child {
		margin-left: 0;
	}

	.social-links .item a {
		width: 28px;
		height: 28px;
		display: inline-block;
		border-radius: 50%;
	}

	.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
        opacity: 1;
    }

    .close-btn {
        opacity: 1;
    }

    .close-icon, .close-icon-active {
        width: 24px;
        height: 24px;
    }

    .close-icon-active {
        display: none;
    }
    
    .close-btn:hover .close-icon {
        display: none;
    }

    .close-btn:hover .close-icon-active {
        display: inline-block;
    }

	.bottom-menu .links a {
		color: var(--gray-dark);
		font-size: 13px;
		text-transform: uppercase;
		/*font-weight: 600;*/
		font-family: var(--primary-font);
		display: block;
		padding: 4px 10px 4px 30px;
		margin: 2px 0;
	}
	
	.bottom-menu .links a:hover {
		background: rgba(247, 195, 114, 0.8);
		color: #fff;
	}

	.sub-title {
		/*font-weight: 600;*/
		font-family: var(--primary-font);
		padding: 0 0 0 30px;
	}

	.side-bar-links {
		flex-flow: column;
	}

	.side-bar-links .item a {
		color: #434343;
		display: flex;
		align-items: center;
		padding: 8px 0 8px 30px;
		text-transform: uppercase;
		font-family: var(--primary-font);
		font-size: 13px;
		margin: 0 0 2px 0;
	}

	.side-bar-links .item a:hover {
		background: var(--primary);
		color: #fff;
	}

	.side-bar-links img {
		margin-right: 6px;
	}

	.w-20 {
		width: 20px;
	}

	img {
		max-width: 100%;
	}


	@media only screen and (min-width: 320px) and (max-width: 766px) {

		.close-icon {
			width: 30px;
			height: 30px;
		}
	}
</style>